import { Injectable } from '@angular/core';
import {  HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { School, SchoolCategory, Region, Country, Year, Subject, User, Grade, Class } from '../model/school.model';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SchoolManagementService {
  headers: any;
  options: any;

  constructor( private http: HttpClient) {
      const headersItem = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'CTL ' + localStorage.getItem('token')
      });
      this.headers = headersItem;
  }

  list(projectId: string): Observable<School[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'schools/project/' + projectId, this.options)
          .pipe(map((response: any) => response ));
  }

  detail(schoolId: string): Observable<School[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'school/' + schoolId, this.options)
          .pipe(map((response: any) => response ));
  }

  search(projectId, filter: any): Observable<School[]> {
    // add header
    this.options = {headers: this.headers};
    let params = new HttpParams();

    for (const prop in filter) {
      if (prop){
        if (filter[prop]){
          params = params.set(prop, filter[prop]);
        }
      }
    }

    this.options = {headers: this.headers, params};
    return this.http.get(environment.restAPI + 'schools/project/' + projectId, this.options)
        .pipe(map((response: any) => response ));
  }

  downloadSchoolList(projectId): Observable<Blob> {
    let params = new HttpParams();
    params = params.set('action', 'download');

    this.options = { headers: this.headers, responseType: Blob, params};
    return this.http.get(environment.restAPI + 'schools/project/' + projectId, this.options)
        .pipe(map((response: any) => response.blob() ));
  }

  disable(schoolId: string) {
      this.options = {headers: this.headers};
      const body: any = {active: false};
      return this.http.put(environment.restAPI + 'school/' + schoolId, body, this.options)
          .pipe(map((response: any) => response ));
  }

  enable(schoolId: string) {
      this.options = {headers: this.headers};
      const body: any = {active: true};
      return this.http.put(environment.restAPI + 'school/' + schoolId, body, this.options)
          .pipe(map((response: any) => response ));
  }

  archive(school_id: string) {
      //
  }

  restore(school_jd: string) {
      //
  }

  create(data: any) {
      this.headers.append('Accept', 'application/json');
      this.options = {headers: this.headers};
      return this.http.post(environment.restAPI + 'school', data, this.options)
          .pipe(map((response: any) => response ));
  }

  update(schoolId: string, data: any) {
      this.headers.append('enctype', 'multipart/form-data');
      this.headers.append('Accept', 'application/json');
      this.options = {headers: this.headers};

      return this.http.put(environment.restAPI + 'school/' + schoolId, data, this.options)
          .pipe(map((response: any) => response ));
  }

  listRegion(projectId: string): Observable<Region[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'regions/project/' + projectId, this.options)
          .pipe(map((response: any) => {
              return response;
          }));
  }

  addRegion(data: any) {
      this.headers.append('Accept', 'application/json');
      this.options = {headers: this.headers};
      return this.http.post(environment.restAPI + 'region', data, this.options)
          .pipe(map((response: any) => {
              return response;
          }));
  }

  listCountry(): Observable<Country[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'countries', this.options)
          .pipe(map((response: any) => {
              return response.json();
          }));
  }

  listSchoolCategory(): Observable<SchoolCategory[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'schoolcategories', this.options)
      .pipe(map((response: any) => {
          return response;
      }));
  }

  listSchoolAdmin(data: any): Observable<User[]> {
    let params = new HttpParams();

    for (const prop in data) {
        if ( !data[prop] ) {
            continue;
        }
        params = params.set(prop, data[prop]);
    }

    this.options = {headers: this.headers, params};
    return this.http.get(environment.restAPI + 'users', this.options)
        .pipe(map((response: any) => {
            return response.json();
        }));
  }

  listGradeSubject(schoolId: string, filter: any): Observable<Grade[]> {
    // let options = new RequestOptions({ headers: this.headers });
    let params = new HttpParams();

    for (const prop in filter) {
      if (prop){
        params = params.set(prop, filter[prop]);
      }
    }

    this.options = {headers: this.headers, params};
    return this.http.get(environment.restAPI + 'grades/school/' + schoolId, this.options)
        .pipe(map((response: any) => {
            return response.json();
        }));
  }

    /* get class subject also */
  listGrade(schoolId?: string): Observable<Grade[]> {
    let params = new HttpParams();
    if (schoolId) {
      params = params.set('school_id', schoolId);
    }
    this.options = {headers: this.headers, params};
    return this.http.get(environment.restAPI + 'grades', this.options)
        .pipe(map((response: any) => response ));

  }

  listClass(schoolId?: string): Observable<Class[]> {
      let params = new HttpParams();
      if (schoolId) {
        params = params.set('school_id', schoolId);
      }
      this.options = {headers: this.headers, params};
      return this.http.get(environment.restAPI + 'classes', this.options)
          .pipe(map((response: any) => response ));

  }

  listYear(): Observable<Year[]> {
      // let options = new RequestOptions({ headers: this.headers });
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'years', this.options)
          .pipe(map((response: any) => response ));
  }

  listProjectYear(projectId?: string): Observable<Year[]> {
      // let options = new RequestOptions({ headers: this.headers });
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'years/project/' + projectId, this.options)
          .pipe(map((response: any) => response ));
  }

  listSubject(schoolId?: string): Observable<Subject[]> {
      // let options = new RequestOptions({ headers: this.headers });
      this.options = {headers: this.headers};
      if (schoolId) {
          return this.http.get(environment.restAPI + 'subjects/school/' + schoolId, this.options)
              .pipe(map((response: any) => response));
      } else {
          return this.http.get(environment.restAPI + 'subjects', this.options)
              .pipe(map((response: any) => response));
      }
  }

  listProjectSubject(projectId: string): Observable<Subject[]> {
      this.options = {headers: this.headers};
      return this.http.get(environment.restAPI + 'subjects/project/' + projectId, this.options)
          .pipe(map((response: any) => response));
  }

  addSchoolAdmin() {
      //
  }

  editschoolAdmin() {
      //
  }

    /* add grade list with class detail */
  addGradeClass(data: any, schoolId?: string) {

      this.headers.append('Accept', 'application/json');
      // add header
      let params = new HttpParams();

      params = params.set('bulk', 'y');
      params = params.set('classes', 'y');

      if (schoolId) {
        params = params.set('school_id', schoolId);
      }

      this.options = {headers: this.headers, params};
      // get users from ap
      return this.http.post(environment.restAPI + 'class', data, this.options)
          .pipe(map((response: any) => response ));
  }

  removeClass(data: any, schoolId?: string){
    this.options = {headers: this.headers, body: data};
    return this.http.delete(environment.restAPI + 'classes/school/'+ schoolId, this.options)
        .pipe(map((response: any) => response ));
  }

  removeSetupCancelledClasses(schoolId: string){
    this.options = {headers: this.headers};
    return this.http.delete(environment.restAPI + 'classes?school_id=' + schoolId, this.options)
        .pipe(map((response: any) => response ));
  }

  addGradeSubject(data: any, schoolId?: string) {

    // add header
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('subjects', 'y');

    if (schoolId) {
      params = params.set('school_id', schoolId);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'class', data, this.options)
        .pipe(map((response: any) => response ));
  }

  assignSubjectTeacher(data: any) {
    // add header
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('subjects', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'class', data, this.options)
        .pipe(map((response: any) => response ));
  }

  updateAssignSubjectTeacher(classId: string, data: any) {
  // add header
    let params = new HttpParams();

    params = params.set('assign', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'class/' + classId, data, this.options)
      .pipe(map((response: any) => response ));

  }

  editGradeSubject() {
      //
  }

  setup() {
      // add/update year/subject
  }

  importSchoolUserData(data) {
      // add authorization header with jwt token
      this.headers.append('Accept', 'application/json');
      this.options = {headers: this.headers};

      return this.http.post(environment.restAPI + 'user/import', data, this.options)
          .pipe(map((response: any) => response ));
  }

  getYearList(project_id?: string): Observable<Year[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'years', this.options)
      .pipe(map((response: any) => response));

  }

  getSubjectList(project_id?: string): Observable<Subject[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'subjects', this.options)
      .pipe(map((response: any) => response));

    // return this.http.get(environment.restAPI + 'project/' + project_id, this.options)
    //         .map((response: Response) => {return response.json(); });
  }

  getProjectSubjectList(project_id?: string): Observable<Subject[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.restAPI + 'project/' + project_id, this.options)
            .pipe(map((response: any) => response ));
  }

  /* get class subject also */
  getGradeList(schoolId?: string): Observable<Grade[]> {

    // add header
    let params = new HttpParams();
    if (schoolId) {
      params = params.set('school_id', schoolId);
    }
    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.get(environment.restAPI + 'grades', this.options)
      .pipe(map((response: any) => response));

  }

  getClassList(schoolId?: string): Observable<Class[]> {

    // add header
    let params = new HttpParams();
    if (schoolId) {
      params = params.set('school_id', schoolId);
    }
    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.get(environment.restAPI + 'classes', this.options)
      .pipe(map((response: any) => response));

  }

  /* grade list should suffice, remove me */
  getGradeClassList(school_id?: string): Observable<Grade[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'classes/grades', this.options)
      .pipe(map((response: any) => response));

  }


  updateGradeClass(grade_id: string, data: any, school_id?: string) {

    // add header
    let params = new HttpParams();

    params.set('classes', 'y');
    if (school_id) {
      params = params.set('school_id', school_id);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'grade/' + grade_id, data, this.options)
      .pipe(map((response: any) => response));

  }

  updateGradeSubject(grade_id: string, data: any, school_id?: string) {

    // add header
    let params = new HttpParams();

    params.set('subjects', 'y');
    if (school_id) {
      params = params.set('school_id', school_id);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'grade/' + grade_id, data, this.options)
      .pipe(map((response: any) => response));

  }

  assignTeacher(data: any) {

    // add header
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('assign', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'user', data, this.options)
      .pipe(map((response: any) => response));

  }

  updateClassSubjectAssignment(user_id: string, data: any) {

    // add header
    let params = new HttpParams();

    params = params.set('assign', 'y');

    this.options = {headers: this.headers , params};
    // get users from ap
    return this.http.put(environment.restAPI + 'user/' + user_id, data, this.options)
      .pipe(map((response: any) => response));

  }

  uploadAddTeachersNStudentExcel(data: any) {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.post(environment.restAPI + 'provision/users', data, this.options)
      .pipe(map((response: any) => { return response;}));

  }

  checkForNewClasses(params) {

    return this.http.post(environment.restAPI + 'checkForNewClasses',
       params, {}).pipe(map((res: any) => res));

  }

  getSubjectListFromObjectIds(params) {
     return this.http.post(environment.restAPI + 'getSubjectListFromObjectId',
       params, {

     }).pipe(map((res: any) => res));
  }

  getTeacherList(params) {
    return this.http.post(environment.restAPI + 'getTeacherList_SA',
      params, {

    }).pipe(map((res: any) => res));
  }

  finalStepForSetupYourSchool(params, isEditMode) {
    let apiName;
    if (isEditMode) {
      apiName = 'editSetUpYourSchool';
    } else {
      apiName = 'copyTempCollectionToUsers';
    }
    return this.http.post(environment.restAPI + apiName,
       params, {
      }).pipe(map((res: any) => res));
  }

  downloadTemplate() {

    return this.http.get(environment.restAPI + 'downloadAddStudentsAndTeachersTemplate',
       {

     }).pipe(map((res: any) => res));

  }

  getGradeandClassesForSchool(schoolCode) {

    console.log('schoolCode :: ' + schoolCode);
    return this.http.get(environment.restAPI + 'getGradeandClassesForSchool?schoolCode=' + schoolCode,
        {
        }).pipe(map((res: any) => res));
  }

  getListOfGradewiseSubjects(schoolCode) {

    const params = {
      schoolCode: schoolCode
    };
    // add header
    this.options = {headers: this.headers};
    // get users from ap
    console.log('params :: ' + params);
    return this.http.post(environment.restAPI + 'grades', this.options)
      .pipe(map((res: any) => res));

  }

  getAssignedTeacherListForEdit(schoolCode) {

    const params = {
      schoolCode: schoolCode
    };
    console.log('params :: ' + params);
    return this.http.post(environment.restAPI + 'fetchTeacherSubjectMappingGradeClasswise',
    params, {

    }).pipe(map((res: any) => res));

  }

  assignClassSubjectTeacher(data: any, schoolId) {

    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('school_id', schoolId);

    this.options = {headers: this.headers, params};
    return this.http.put(environment.restAPI + 'class', data, this.options)
        .pipe(map((response: any) => response));
  }
}
